export default {
      id: "app-store-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#app-store",
      toString: function () {
        return this.url;
      }
    }